<app-modal 
  [title]="dictionaryService.get('RejectPlanDraft') || 'Reject Plan Draft'" 
  [(opened)]="isOpen" 
  size="md" 
  (closeTrigger)="handleClose()">
  
  @if (isOpen()) {
  <div class="modal-content-wrapper">
    <div class="modal-scrollable-content">
      <div class="rejection-form">
        <div class="input-group">
          <span class="input-label">
            {{ dictionaryService.get('RejectionMessage') || 'Rejection Message' }} *
          </span>
          <app-input
            type="text"
            [initialValue]="rejectionMessage()"
            (onChange)="rejectionMessage.set($event)"
            [placeholder]="dictionaryService.get('EnterRejectionReason') || 'Enter rejection reason'"
            size="md"
            name="rejection-message"
          ></app-input>
        </div>
      </div>
    </div>
    
    <!-- Footer Buttons - Fixed at bottom -->
    <div class="modal-footer">
      <button
        buttonTheme="light"
        buttonType="regular"
        size="rg"
        (click)="handleClose()"
        [disabled]="isProcessing()"
        class="cancel-btn">
        {{ dictionaryService.get('Cancel') || 'Cancel' }}
      </button>
      <button
        buttonTheme="primary"
        buttonType="regular"
        size="rg"
        (click)="handleSubmit()"
        [disabled]="isProcessing() || !rejectionMessage().trim()">
        {{ dictionaryService.get('Reject') || 'Reject' }}
      </button>
    </div>
  </div>
  }
</app-modal>
